import React from 'react';
import {FormattedMessage} from 'react-intl';
import {can} from '../../../../_common/components/Permissions';

const Link = ({children, ...rest}) => (
  <a
    className="text-dark-75 font-weight-bolder d-block font-size-lg"
    {...rest}
  >
    {children}
  </a>
);

const Text = ({children, ...rest}) => (
  <div
    className="text-dark-75 font-weight-bolder d-block font-size-lg"
    {...rest}
  >
    {children}
  </div>
);

const Name = ({firstName, lastName}) => (
  (firstName && lastName)
    ? `${firstName} ${lastName}`
    : (
      <FormattedMessage
        id="users-column-fullName-doesNot-exist"
        defaultMessage="Full name does not exist"
      />
    )
);

export function UserNameAndEmailColumnFormatter(
  cellContent,
  row,
  rowIndex,
  {history}
) {
  const handleClick = () => history.push(`/user/${row._id}`);

  const emails = row.emails.map(email => (
    <span className="text-muted font-weight-bold">
        {email.address}
    </span>
  ));

  return (
    <>
      {can('view', 'userPage')
        ? (
          <Link onClick={handleClick}>
            <Name {...row}/>
          </Link>
        )
        : (
          <Text>
            <Name {...row}/>
          </Text>
        )}
      {emails}
    </>
  );
}
